import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'

import { Button, Input, Icon } from 'loyal-react'
import BoxTempPassword from './BoxTempPassword'
import BoxUnconfirmed from './BoxUnconfirmed'
import BoxOnboardingLink from '../Onboarding/BoxOnboardingLink'
import isEnv from '../../isEnv'
import MediaQuery from 'react-responsive'

const BoxRequestCode = ({
  handleSendCode,
  handleResendPass,
  handleResendConfirmEmail,
  email,
  login,
  error,
  statusCognito,
  isLoading,
  handleChange,
  location: { search },
  ...rest
}) => {
  const changeTempPassword = statusCognito === 'FORCE_CHANGE_PASSWORD'
  const userUnconfirmed = statusCognito === 'UNCONFIRMED'
  const isOnboardingEnabled = isEnv(process.env.RAZZLE_ONBOARDING_ENABLED)
  return (
    <>
      <div id='box-forgotPassword' className='box-login box-forgotPassword row pb-4'>
        <div className='col-12 col-md-6 col-lg-5 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a
                    id='image-link'
                    href={`/login${search}`}
                    className='txt-body-sm d-block'
                    tabIndex='0'
                    aria-label='Voltar'
                    role='button'
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a
                    href={`/login${search}`}
                    className='txt-body-sm d-block'
                    tabIndex='0'
                    aria-label='Voltar'
                    role='button'
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
            {isOnboardingEnabled ? (
              changeTempPassword ? (
                <>
                  <BoxTempPassword email={email} />
                </>
              ) : userUnconfirmed ? (
                <>
                  <BoxUnconfirmed email={email} />
                </>
              ) : (
                <div className='col-12'>
                  <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>Esqueceu a senha?</h1>
                  <p className='txt-body-sm'>Receba instruções para criar uma nova senha.</p>
                  <p className='txt-body-sm mb-1'>Ao clicar em continuar um código sera enviado no e-mail:</p>
                  <div className='row'>
                    <p className='col-12 txt-body-sm color-brand-2'>{email}</p>
                  </div>
                </div>
              )
            ) : (
              <div className='col-12'>
                <h1 className='h1 color-brand-1 txt-circular-book mb-1'>Esqueceu a senha?</h1>
                <p className='txt-body-sm'>Receba instruções para criar uma nova senha.</p>
                <p className='txt-body-sm mb-1'>Ao clicar em continuar um código sera enviado no e-mail cadastrado.</p>
                <div className='row'>
                  <Input
                    id='documento'
                    name='login'
                    label='CPF ou CPNJ'
                    className='col-12 col-md-12 mt-1'
                    value={login}
                    onChange={handleChange}
                    valid={error ? false : undefined}
                    data-error={error && error.message}
                  />
                </div>
              </div>
            )}
          </div>
          {error && (
            <div className='col-12 col-md-12 px-0'>
              <div className='txt-left'>
                <span className='txt-subtitle txt-opensans color-error' role='alert'>
                  {error ? error.message : ''}
                </span>
              </div>
            </div>
          )}
          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <Button
              id='btn-resend'
              disabled={false}
              loading={isLoading}
              onClick={
                changeTempPassword ? handleResendPass : userUnconfirmed ? handleResendConfirmEmail : handleSendCode
              }
              className='btn btn-sm btn-featured'
              text={changeTempPassword || userUnconfirmed ? 'Reenviar e-mail' : 'Continuar'}
            />
          </div>

          {isOnboardingEnabled ? <BoxOnboardingLink {...rest} login={login} /> : null}
        </div>
      </div>
    </>
  )
}

BoxRequestCode.propTypes = {
  handleSendCode: PropTypes.func,
  handleResendPass: PropTypes.func,
  handleResendConfirmEmail: PropTypes.func,
  email: PropTypes.string,
  login: PropTypes.string,
  error: PropTypes.string,
  statusCognito: PropTypes.string,
  isLoading: PropTypes.bool
}

export default withRouter(BoxRequestCode)
